import * as React from 'react';
import { isUSA } from '../../config'
import { IDocument, IOrderQuantities_Addresses, IState, IUserData } from '../../infrastructure/interfaces';
import OrderPrintsModal from './OrderPrintsModal';

export interface IShippingInfoWarningModalProps {
  show: any;
  onClose: any;
  document: IDocument | null;
  statesList: IState[] | null;
  userData: IUserData;
  valid: boolean;
  onPlaceOrder?(document: IDocument, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]): void;
}

export interface IShippingInfoWarningModalState {
  document: IDocument | null;
  orderComments: string;
  orderQuantityAddressPairs: IOrderQuantities_Addresses[];
  editedDocument: IDocument | null;
  statesList: IState[] | null;
  selectedOrderQuantityAddressPair: IOrderQuantities_Addresses;
  orderQuantityAddressPairIndex: number;
}

export default class ShippingInfoWarningModal extends React.Component<IShippingInfoWarningModalProps, IShippingInfoWarningModalState> {
  constructor(props: IShippingInfoWarningModalProps) {
    super(props);
    this.state = {
      document: props.document,
      orderComments: '',
      orderQuantityAddressPairs: [],
      editedDocument: props.document,
      statesList: props.statesList,
      selectedOrderQuantityAddressPair: {
        address: {
          shipName: '',
          shipAddress1: '',
          shipAddress2: '',
          shipCity: '',
          shipState: '',
          shipPostalCode: '',
          shipCountry: isUSA() ? "United States" : "Canada",
          divisionId: ''
        },
        orderQuantity: 0
      },
      orderQuantityAddressPairIndex: 0
    };
  }

  componentWillReceiveProps(nextProps: IShippingInfoWarningModalProps) {
    if (nextProps.document !== this.props.document || nextProps.statesList !== this.props.statesList) {
      this.setState({
        document: nextProps.document,
        editedDocument: nextProps.document,
        statesList: nextProps.statesList,
      });
    }
  }

  onClose = () => {
    this.setState({
      orderQuantityAddressPairs: [],
      orderComments: '',
      selectedOrderQuantityAddressPair: {
        address: {
          shipName: '',
          shipAddress1: '',
          shipAddress2: '',
          shipCity: '',
          shipState: '',
          shipPostalCode: '',
          shipCountry: isUSA() ? "United States" : "Canada",
          divisionId: ''
        },
        orderQuantity: 0
      },
      orderQuantityAddressPairIndex: 0
    });
    this.props.onClose();
  }

  onPlaceOrder = () => {
    this.setState({
      document: this.state.editedDocument,
    });
    if (this.props.onPlaceOrder && this.state.editedDocument) {
      this.props.onPlaceOrder(this.state.editedDocument, this.state.orderComments, this.state.orderQuantityAddressPairs);
    }
  }

  onSaveOrderQuantityAddressPair = (orderQuantityAddressPair: IOrderQuantities_Addresses) => {
    if (this.state.orderQuantityAddressPairs.length >= this.state.orderQuantityAddressPairIndex) {
      let updatedOrderQuantityAddressPairs = this.state.orderQuantityAddressPairs;
      updatedOrderQuantityAddressPairs[this.state.orderQuantityAddressPairIndex] = orderQuantityAddressPair;
      this.setState({
        orderQuantityAddressPairs: updatedOrderQuantityAddressPairs,
        orderQuantityAddressPairIndex: -1
      });
    }
  }

  onStartNewOrderQuantityAddressPair = () => {
    let orderQuantityAddressPair: IOrderQuantities_Addresses = {
      address: {
        shipName: '',
        shipAddress1: '',
        shipAddress2: '',
        shipCity: '',
        shipState: '',
        shipPostalCode: '',
        shipCountry: isUSA() ? "United States" : "Canada",
        divisionId: ''
      },
      orderQuantity: 0
    }
    let updatedOrderQuantityAddressPairs = this.state.orderQuantityAddressPairs;
    updatedOrderQuantityAddressPairs.push(orderQuantityAddressPair);
    this.setState({
      orderQuantityAddressPairs: updatedOrderQuantityAddressPairs,
      orderQuantityAddressPairIndex: updatedOrderQuantityAddressPairs.length - 1,
      selectedOrderQuantityAddressPair: orderQuantityAddressPair
    });
  }

  onSelectedEditOrderQuantityAddressPair = (itemIndex: number) => {
    if (this.state.orderQuantityAddressPairs.length >= this.state.orderQuantityAddressPairIndex) {
      this.setState({
        orderQuantityAddressPairIndex: itemIndex,
        selectedOrderQuantityAddressPair: this.state.orderQuantityAddressPairs[itemIndex]
      })
    }
  }

  onSelectedDeleteOrderQuantityAddressPair = (itemIndex: number) => {
    if (this.state.orderQuantityAddressPairs.length >= itemIndex) {
      let updatedOrderQuantityAddressPairs = this.state.orderQuantityAddressPairs;
      updatedOrderQuantityAddressPairs.splice(itemIndex, 1);
      this.setState({
        orderQuantityAddressPairs: updatedOrderQuantityAddressPairs,
        orderQuantityAddressPairIndex: 0,
      })
    }
  }

  onFieldChange = (e: any) => {
    const {
      name,
      value,
    } = e.target;

    let updatedOrderQuantityAddressPairs = this.state.orderQuantityAddressPairs;
    let updatesOrderQuantityAddressPair = this.state.selectedOrderQuantityAddressPair;
  
    if (name == "orderQuantity") {
      updatesOrderQuantityAddressPair.orderQuantity = value;
    } else {
      updatesOrderQuantityAddressPair.address[name] = value;
    }

    this.setState({
      selectedOrderQuantityAddressPair: updatesOrderQuantityAddressPair,
      orderQuantityAddressPairs: updatedOrderQuantityAddressPairs
    });
  }

  onDocumentNameFieldChange = (e: any) => {
    const {
      value,
    } = e.target;
    this.setState({
      editedDocument: {
        ...this.state.editedDocument!,
        name: value,
      },
    });
  }

  onOrderCommentsFieldChange = (e: any) => {
    const {
      value,
    } = e.target;
    this.setState({
      ...this.state,
      orderComments: value,
    });
  }

  render() {
    return (this.props.show &&
      <OrderPrintsModal
        document={this.props.document}
        comments={this.state.orderComments}
        orderQuantityAddressPairs={this.state.orderQuantityAddressPairs}
        selectedOrderQuantityAddressPair={this.state.selectedOrderQuantityAddressPair}
        orderQuantityAddressPairIndex={this.state.orderQuantityAddressPairIndex}
        userData={this.props.userData}
        show={this.props.show}
        onClose={this.onClose}
        state={this.state}
        onPlaceOrder={this.onPlaceOrder}
        onSaveOrderQuantityAddressPair={this.onSaveOrderQuantityAddressPair}
        onStartNewOrderQuantityAddressPair={this.onStartNewOrderQuantityAddressPair}
        onSelectedEditOrderQuantityAddressPair={this.onSelectedEditOrderQuantityAddressPair}
        onSelectedDeleteOrderQuantityAddressPair={this.onSelectedDeleteOrderQuantityAddressPair}
        onFieldChange={this.onFieldChange}
        onDocumentNameFieldChange={this.onDocumentNameFieldChange}
        onOrderCommentsFieldChange={this.onOrderCommentsFieldChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/ShippingInfoWarningModal.tsx